var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loadWindow},[_c('l-loading-window',_vm._b({attrs:{"title":"Обновление системы"},on:{"finish":function($event){return _vm.$emit('finish', $event)}}},'l-loading-window',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }